import { render } from "./Owners.vue?vue&type=template&id=6cb7698e"
import script from "./Owners.vue?vue&type=script&lang=js"
export * from "./Owners.vue?vue&type=script&lang=js"

import "./Owners.vue?vue&type=style&index=0&id=6cb7698e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__